import { render, staticRenderFns } from "./video-list-card.vue?vue&type=template&id=0dcc5d6c&scoped=true"
import script from "./video-list-card.vue?vue&type=script&lang=js"
export * from "./video-list-card.vue?vue&type=script&lang=js"
import style0 from "./video-list-card.vue?vue&type=style&index=0&id=0dcc5d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc5d6c",
  null
  
)

export default component.exports